import styled from 'styled-components'

export const Para = styled.p`
    margin-bottom: 50px;
    color: #311b92;
    font-weight: bold;
    letter-spacing: 0.05rem;
    font-size: 1.2rem;
`

export const TitleDiv = styled.div`
    position: absolute;
    top: 6.5rem;
    right: 17%;
    text-align: right;
    @media (min-width: 1600px) {
        right: 20%;
    }
    @media (min-width: 1985px) {
        right: 22%;
    }
`
